/**
 * Saves the strength a customer adds to the cart, so
 * snippets/preferred-strength.liquid can open the next product page at it.
 *
 * The value is read from the option inputs of the form that was submitted, and
 * only after the cart accepts the line, so a refused add leaves it alone.
 */
import { savePreferredStrength } from './preferred-strength.js';

// The try-on cart builds its inputs in JS with the untranslated option name.
const FALLBACK_OPTION_NAME = 'Strength';

let pendingStrength = null;

function optionNames() {
  const localised = window.theme?.strings?.strengthOptionName;
  return localised && localised !== FALLBACK_OPTION_NAME ? [localised, FALLBACK_OPTION_NAME] : [FALLBACK_OPTION_NAME];
}

// Radios first: a form that holds both radios and a hidden popout input for one
// option keeps the truth on the checked radio.
function strengthInForm(form) {
  for (const name of optionNames()) {
    const inputs = [...form.querySelectorAll(`[name="options[${name}]"]`)];
    const selected = inputs.find((input) => input.checked) || inputs.find((input) => input.type !== 'radio');
    if (selected?.value) return selected.value;
  }
  return null;
}

document.addEventListener('theme:cart:add', (event) => {
  const form = event.detail?.selector?.closest?.('form');
  pendingStrength = form ? strengthInForm(form) : null;
});

document.addEventListener('theme:cart:added', () => {
  savePreferredStrength(pendingStrength);
  pendingStrength = null;
});
